import React from 'react';
import { Helmet } from 'react-helmet';

import MagooshLogo from '@magoosh/assets/magoosh-logo-purple.png';
import Footer from '@magoosh/organisms/footer';
import Rocket from '@schools/app/assets/rocket.png';
import style from './style.module.scss';

interface Props {}

const NotFound: React.FC<Props> = (props) => {
  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
      <Helmet>
        <title>Not Found - School Profiles</title>
      </Helmet>

      <div className={style.fixedNavbar}>
        <div className="container align-items-center d-flex u-padding-V-m">
          <div>
            <a href="https://magoosh.com">
              <img alt="Magoosh" className={style.logo} src={MagooshLogo} />
            </a>
          </div>
        </div>
      </div>

      <div className="align-items-center container d-flex flex-1 flex-column justify-content-center u-padding-V-xl">
        <img src={Rocket} style={{ height: 'auto', width: 350 }} />

        <h3 className="text-center text-primary">
          <strong>Sorry! We don't have the page you're looking for.</strong>
        </h3>

        <p>Email us at <a className="text-primary" href="mailto:help@magoosh.com">help@magoosh.com</a> if you're lost.</p>
      </div>

      <div className="u-margin-T-xl">
        <Footer />
      </div>
    </div>
  );
};

export default NotFound;
